import { AxiosGet } from "../AxiosWrapper";
import { MANAGEMENT_SERVICE_URL } from "../../constants/ServiceUrls";

export const getLicensingTerms = () => {
  return AxiosGet(`${MANAGEMENT_SERVICE_URL}api/Licensing/GetTerms`);
};

export default {
  getLicensingTerms,
};
